<template>
  <FormResponsePageTemplate
    :intro="intro"
    :text="text"
    background-color="#4a31c0"
    icon-color="white"
    text-color="white"
    :next="next"
  >
  </FormResponsePageTemplate>
</template>

<script>
import FormResponsePageTemplate from "../components/templates/FormResponsePageTemplate.vue";

export default {
  data: () => ({
    intro: "Seu voto foi enviado com sucesso.",
    text: "Muito obrigado!",
    next: "/professor",
  }),
  components: { FormResponsePageTemplate },
};
</script>
